import type { VoucherForCampaignNewItem_EditPageQuery } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { FeatureIslandContainer, FeatureIslandHeader } from "@/components/features/_layouts";

import { MarketingNewCampaignFormModelContextProvider } from "./context";
import { useInitialized } from "../../model/usecase/new/use-init";
import { QuestionCampaignBase } from "../_shared/components/base/root";
import { QuestionCampaignList } from "../_shared/components/list/root";
import { HeaderPublishButton } from "./components/header/publish-button/publish-button";
import { HeaderSaveButton } from "./components/header/save-button/save-button";

import type { MarketingCampaignFormModel } from "../../model";

type Props = {
	hotelID: string;
	data: VoucherForCampaignNewItem_EditPageQuery;
	queryData: MarketingCampaignFormModel["QueryData"];
};

export const NewCampaignEditPresenter = ({ data, queryData }: Props) => {
	const init = useInitialized({
		data,
		queryData,
	});
	const { isDirty } = init.viewModel;

	useTransitionBlock(isDirty);

	return (
		<MarketingNewCampaignFormModelContextProvider value={{ ...init }}>
			<FeatureIslandContainer>
				<FeatureIslandHeader
					title="新しいキャンペーンの作成"
					rightChildren={
						<div className="flex gap-x-6">
							<HeaderSaveButton />
							<HeaderPublishButton />
						</div>
					}
				/>

				<QuestionCampaignList />
				<QuestionCampaignBase />
			</FeatureIslandContainer>
		</MarketingNewCampaignFormModelContextProvider>
	);
};

NewCampaignEditPresenter.displayName = "NewCampaignEditPresenter";
